exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".authLayoutContentWrapper--lKrPH {\r\n\tpadding-top: 72px !important;\r\n}\r\n", ""]);

// Exports
exports.locals = {
	"authLayoutContentWrapper": "authLayoutContentWrapper--lKrPH"
};